var set = {};
export default (function (maxWidth) {
  if (maxWidth === undefined || maxWidth === null) {
    return;
  }

  if (!(maxWidth in set)) {
    set[maxWidth] = {
      maxWidth: maxWidth
    };
  }

  return set[maxWidth];
});